<div class="invoice" *ngIf="invoiceDetail?.length">
    <ng-container *ngFor="let item of invoiceDetail; let i= index">
        <a (click)="navigate(item.poId)" class="invoice-item" *ngIf="i <= 3">
            {{item.invoiceNo}}
        </a>
    </ng-container>   
    <ng-container *ngIf="invoice.length > 4" >
        <div class="invoice-count">
            {{invoice.length - 4}}+
        </div>
        <div class="invoice-item view-all" [matMenuTriggerFor]="invoiceMenu">
            View all
        </div>
    </ng-container>
    
</div>

<mat-menu #invoiceMenu="matMenu" class="mat-menu-primary">
    <div *ngFor="let item of invoiceDetail; let i= index">
        <a (click)="navigate(item.poId)" mat-menu-item *ngIf="i > 3">{{item.invoiceNo}}</a>
    </div>   
  </mat-menu> 